import type { NomenclatureUpload } from "../types";

export type UploadStepState = "done" | "current" | "todo";

export const UPLOAD_SECTION_IDS = {
  upload: "upload-section",
  check: "check-section",
  pending: "pending-section",
  tds: "tds-section",
  rowGuide: "row-guide-section",
} as const;

export interface UploadStep {
  title: string;
  description: string;
  state: UploadStepState;
  sectionId: string;
}

export function uploadSteps(upload: NomenclatureUpload | null, pendingCodeCount: number): UploadStep[] {
  const hasFile = upload !== null && upload.uploadStatus !== "Discarded";
  const isSaved = upload?.uploadStatus === "Committed";
  const waitingRowCount = upload?.rowCounts.Waiting ?? 0;
  const isWaitingOnCodes = hasFile && (waitingRowCount > 0 || pendingCodeCount > 0);

  return [
    {
      title: "Upload",
      description: "Drop the nomenclature file",
      state: hasFile ? "done" : "current",
      sectionId: UPLOAD_SECTION_IDS.upload,
    },
    {
      title: "Check before saving",
      description: "Every row checked against its own columns",
      state: hasFile ? "done" : "todo",
      sectionId: UPLOAD_SECTION_IDS.check,
    },
    {
      title: "Save",
      description: "Valid rows go to the database",
      state: isSaved ? "done" : hasFile ? "current" : "todo",
      sectionId: UPLOAD_SECTION_IDS.check,
    },
    {
      title: "Approve new codes",
      description: "Waiting rows save once their codes are approved",
      state: isWaitingOnCodes ? "current" : isSaved ? "done" : "todo",
      sectionId: UPLOAD_SECTION_IDS.pending,
    },
  ];
}
